import React, { createContext, useState } from 'react'

export const TourContext = createContext({
    isTourActive: false,
    currentStep: 0,
    startTour: () => {},
    nextStep: () => {},
    endTour: () => {}
})

export const TourProvider = ({ children }) => {
    const [isTourActive, setIsTourActive] = useState(false)
    const [currentStep, setCurrentStep] = useState(0)

    const startTour = () => {
        setCurrentStep(0)
        setIsTourActive(true)
    }

    const nextStep = () => {
        setCurrentStep(prev => prev + 1)
    }

    const endTour = () => {
        setIsTourActive(false)
        setCurrentStep(0)
    }

    return (
        <TourContext.Provider
            value={{
                isTourActive,
                currentStep,
                startTour,
                nextStep,
                endTour
            }}
        >
            {children}
        </TourContext.Provider>
    )
}
